import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'wouter';
import { Observer } from '../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../Legacy';
import { Icon } from '../../../concepts/resources/Icon';
import { SortMode, applyFilter, applySort } from '../../common/Sorter';
import { BoardModel } from '../Models';
import { BoardActionMenu } from './BoardActionMenu';
import { BoardParticipantPreview } from './BoardParticipantPreview';
import { BoardThumb } from './BoardThumb';
import { ContentGrid } from './LayoutElements';

const { Item, ItemHeading, ItemButton, ItemBorder, ItemInfo } = ContentGrid;

const ItemPin = styled.span`
    display: inline-block;
    transform: translate(-0.3rem,0rem) rotate(-85deg) scale(0.8);
`;

export type BoardGridProps = {
    actions?: boolean | Record<string, boolean>,
    boards?: readonly BoardModel[],
    sort?: SortMode,
    filter?: string,
};

export const BoardGrid: LFC<BoardGridProps> = ({ actions, boards, sort, filter }) => {

    const [tick, setTick] = useState(0);
    const reduced = useMemo(
        () => applySort(applyFilter(boards ?? [], filter), sort, ['pinned', 'asc']),
        [boards, sort, filter, tick]
    );

    return <ContentGrid>
        {reduced && reduced.map(b => <Observer key={b.id} store={b} render={bs =>
            <Item>
                {actions && !b.special && <ItemButton>
                    <BoardActionMenu config={actions} board={bs} onLayoutAffected={() => setTick(x => x + 1)} />
                </ItemButton>}
                <Link to={bs.path}>
                    <ItemHeading>
                        {bs.pinned && <ItemPin><Icon size="1.5" src="deqo://icons/i8/pin" /></ItemPin>}
                        {bs.label}
                    </ItemHeading>
                    <ItemBorder>
                        <BoardThumb info={bs} />
                        <BoardParticipantPreview boardId={bs.id} />
                    </ItemBorder>
                    {sort?.[0] === 'createdAt' && <ItemInfo>Created {bs.createdAt && new Date(bs.createdAt).toLocaleDateString()}</ItemInfo>}
                    {sort?.[0] !== 'createdAt' && <ItemInfo>Updated {bs.updatedAt && new Date(bs.updatedAt).toLocaleDateString()}</ItemInfo>}
                </Link>
            </Item>
        } />)}
    </ContentGrid>;
};
